import { useTranslation } from 'react-i18next';
import DropdownComponent from '../../components/common/DropdownComponent/DropdownComponent';
import DropdownFilter from '../../components/common/DropdownFilter/DropdownFilter';
import { getValueFromString } from '../../utils/data/getValue.utils';
import SectionFilter from './components/SectionFilter';
import SectionProductList from './components/SectionProducList';
import { useSearchParams } from 'react-router-dom';
import i18n from '../../languages/i18n';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchProducts } from '../../store/actions/product.action';
import ROUTER from '../../routers/Routers';
import SectionCategory from './components/SectionCategory';

const items = [
  {
    key: null,
    label: (
      <span className="text-body-medium font-semibold">
        {i18n.t('Sắp xếp theo')}
      </span>
    ),
  },
  {
    key: 'size',
    label: (
      <span className="text-body-medium font-semibold">{i18n.t('Size')}</span>
    ),
  },
  {
    key: 'price',
    label: (
      <span className="text-body-medium font-semibold">{i18n.t('Price')}</span>
    ),
  },
];

const CategoryPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { products } = useSelector(state => state.product);

  const [searchParams, setSearchParams] = useSearchParams();
  const sortByParam = searchParams.get('sort');

  const updateSearchParams = (key, value) => {
    // Sử dụng searchParams.entries() để lấy các cặp key-value
    const params = Object.fromEntries(searchParams);
    if (key !== 'offset') {
      if (key === 'sort') {
        if (value) {
          params[key] = value;
        } else {
          delete params[key];
        }
      }
      delete params['offset']; // Reset offset về 0 khi có thay đổi
    } else {
      params[key] = value;
    }
    setSearchParams(params);
  };

  useEffect(() => {
    if (products.isNeedReloadData) dispatch(fetchProducts());
  }, [products.isNeedReloadData]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (!id && products.data?.length) {
      navigate(ROUTER.CATEGORY + '/' + products.data[0]?.id);
    }
  }, [id, products.data]);

  return (
    <div className="flex items-start flex-col justify-start self-stretch grow">
      <SectionCategory />
      <div className="flex lg:px-[80px] lg:py-[40px] px-[16px] py-[32px] flex-col items-center lg:gap-[24px] gap-[16px] self-stretch justify-center">
        <div className="flex items-start self-stretch justify-center">
          <div className="flex justify-between items-center max-w-[1280px] grow">
            <div className="flex items-center lg:gap-[16px] gap-[8px]">
              {(() => {
                const product = products.data?.find(item => item.id === id);
                return (
                  <>
                    <span className="lg:h2 text-headline-small font-semibold">
                      {getValueFromString(product?.name)}
                    </span>
                    <span className="text-body-large flex gap-[4px] items-center">
                      (<span>{product?.total_products || 0}</span>
                      <span className="lg:block hidden">{t('Product')}</span>)
                    </span>
                  </>
                );
              })()}
            </div>
            <DropdownFilter
              trigger={['click']}
              menu={{
                items: items.map(item => {
                  return {
                    key: item.key,
                    label: (
                      <div className="px-[12px] py-[8px] flex items-center ">
                        {item.label}
                      </div>
                    ),
                    onClick: () => {
                      updateSearchParams('sort', item.key);
                    },
                  };
                }),
              }}
              size="small"
              className={'text-black-medium'}
              value={getValueFromString(
                items.find(item => item.key === sortByParam)?.label ??
                  items[0].label
              )}
            />
          </div>
        </div>
        <div className="flex items-start justify-center self-stretch grow">
          <div className="flex lg:flex-row flex-col items-start justify-start gap-[8px] self-stretch">
            <SectionFilter />
            <SectionProductList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryPage;
